/* 
 * Connecting to StalkerPortal library
 * Borshchov Dimitriy (grimstal@bigmir.net)
 */

"use strict";
import { typeCheck, checkObject, checkNumber, checkRest, checkString, checkFunc, checkStringOrObject, checkStringOrNumber } from './type_checker';

export function AuthObject() {

    this.tokenType = null;
    this.accessToken = null;
    this.refreshToken = null;
    this.userID = null;
    this.expiresIn = null;

    this.timeLimit = 30; // set in minutes

    this.set = typeCheck(function set(data) {

        if (data['token_type']) {
            this.tokenType = data['token_type'];
        }

        if (data['access_token']) {
            this.accessToken = data['access_token'];
        }

        if (data['refresh_token']) {
            this.refreshToken = data['refresh_token'];
        }

        if (data['user_id']) {
            this.userID = data['user_id'];
        }

        if (data['expires_in']) {
            this.expiresIn = new Date().getTime() + data['expires_in'] * 1000;
        }

        return true;

    }, [checkObject]);

    this.setTimeLimit = typeCheck(function setTimeLimit(minutes) {

        if (!minutes) {
            return false;
        }

        this.timeLimit = minutes;

    }, [checkNumber]);

    this.isExpire = function () {

        var currentTS = new Date().getTime();
        var checkTS = this.expiresIn - this.timeLimit * 60 * 1000;

        if (currentTS >= checkTS) {
            return true;
        }

        return false;

    };

    this.isLogin = function () {

        if (this.expiresIn === null || this.isExpire()) {
            return false;
        }

        return true;

    };

    this.clear = function () {

        this.tokenType = null;
        this.accessToken = null;
        this.refreshToken = null;
        this.userID = null;
        this.expiresIn = null;

        return true;

    };
}

export function ChannelObject() {
    this.name = null;
    this.URL = null;
    this.channelID = null;
    this.image = null;
    this.tvgName = null;
    this.groupTitle = null;
    this.favorite = 0;

    this.set = typeCheck(function set(obj) {
        if (obj.name) {
            this.name = obj.name;
        }
        if (obj.url) {
            this.URL = obj.url;
        }
        if (obj.channelID) {
            this.channelID = obj.channelID;
        }
        if (obj.image) {
            this.image = obj.image;
        }
        if (obj.tvgName) {
            this.tvgName = obj.tvgName;
        }
        if (obj.groupTitle) {
            this.groupTitle = obj.groupTitle;
        }
        if (obj.favorite) {
            this.favorite = obj.favorite;
        }

        return true;
    }, [checkObject]);

    this.clear = function () {
        this.name = null;
        this.URL = null;
        this.channelID = null;
        this.image = null;
        this.tvgName = null;
        this.groupTitle = null;
        this.favorite = 0;
    };
}

export function EpgObject() {
    this.startTime = null; // unixtime
    this.endTime = null; // unixtime
    this.title = null;
    this.tvgName = null;

    this.set = typeCheck(function set(startTime, endTime, title, tvgName) {
        if (!startTime || !endTime || !title) {
            return false;
        }

        if (tvgName) {
            this.tvgName = tvgName;
        }

        this.startTime = startTime;
        this.endTime = endTime;
        this.title = title;

        return true;
    }, [checkNumber, checkNumber, checkStringOrNumber, checkStringOrNumber]);
}

export function InitObject() {
    this.mac = '';
    this.M3U_url = '';
    this.EPG_url = '';
    this.login = '';
    this.password = '';

    this.setMac = function (mac) {

        if (!mac) {
            return false;
        }

        var temp = mac.trim().replace(/[-]/g, ':');
        var chanReg = /^(?:[A-Fa-f0-9]{2}(?:[:])){5}[A-Fa-f0-9]{2}$/;

        temp = chanReg.exec(temp);

        if (temp === null || typeof (temp) === undefined) {
            return false;
        }

        this.mac = temp[0];

        return true;
    };

    this.setM3U = function (url) {
        if (!url) {
            return false;
        }
        this.M3U_url = url;
        return true;
    };

    this.setEPG = function (url) {
        if (!url) {
            return false;
        }
        this.EPG_url = url;
        return true;
    };

    this.setLogin = function (login) {
        var loginExp = /^[0-9a-zA-Z\-_\.@!]+$/;
        if (!login || !loginExp.exec(login)) {
            return false;
        }
        this.login = login;
        return true;
    };

    this.setPassword = function (password) {
        var passwordExp = /^[0-9a-zA-Z\-_\.@!]*$/;
        if (!password || !passwordExp.exec(password)) {
            return false;
        }
        this.password = password;
        return true;
    };
}

export function RequestParams() {
    this.restMethod;
    this.url;
    this.dataType;
    this.data;
    this.crossDomain;
    this.headers;
    this.timeout = 5000;
    this.successFunction = function () {
    };
    this.errorFunction = function () {
    };

    this.setRequest = typeCheck(function setRequest(restMethod, url,
            successFunction, errorFunction) {
        if (!restMethod || !url || !successFunction || !errorFunction) {
            return false;
        }

        this.restMethod = restMethod;
        this.url = url;
        this.successFunction = successFunction;
        this.errorFunction = errorFunction;

        return true;
    }, [checkRest, checkString, checkFunc, checkFunc]);

    this.setCrossDomain = function (boolean) {
        if (!boolean) {
            return false;
        }
        this.crossDomain = true;
        return true;
    };

    this.setDataType = typeCheck(function setDataType(string) {
        if (!string) {
            return false;
        }
        this.dataType = string;
        return true;
    }, [checkString]);

    this.setData = typeCheck(function setData(string) {
        if (!string) {
            return false;
        }
        this.data = string;
        return true;
    }, [checkStringOrObject]);

    this.setHeaders = typeCheck(function setHeaders(object) {
        if (!object) {
            return false;
        }
        this.headers = object;
        return true;
    }, [checkObject]);

    this.setTimeout = typeCheck(function setTimeout(int) {
        if (!int) {
            return false;
        }
        this.timeout = int;
        return true;
    }, [checkNumber]);
}



// WEBPACK FOOTER //
// ./src/api/objects.js